import React, { useEffect, useState } from 'react';

const IndividualCountrySelect = props => {

    const countryDropdownRef = React.createRef();
    
    const [isCountryDropdown, setIsCountryDropdown] = useState(false);

    useEffect(() => {
        // Open a listener for and mousedown event on body page to close any of the dropdowns
		document.addEventListener('mousedown', onHandleDropdown);
    }, [])

    // Handle dropdown when clicked outside of their container
	const onHandleDropdown = e => {
		if (countryDropdownRef.current && !countryDropdownRef.current.contains(e.target)) {
            setIsCountryDropdown(false);
		}
	}

    // Dropdown for country selector
	const onClickCountryDropdown = () => {
        setIsCountryDropdown(!isCountryDropdown);
	}

    // sends country code to parent component
    const onClickCountry = (countryCode) => {
        return () => {
            props.onClickCountry(countryCode);
        }
    }

    return (
        <div id="filter1" className={`filter--dropdown--wrapper ${isCountryDropdown ? 'viewOptions' : null}`} tabIndex="-1">
            <div className="filter--dropdown--list" ref={ countryDropdownRef }>
                <p className="option-title " onClick={ onClickCountryDropdown }>{ props.literals.L20630 }</p>
                <ul className="filter--dropdown--options ">
                    { props.selectCountries.map((country) => (
                        <li key={country.code} onClick={ onClickCountry(country)} >
                            <input type="checkbox" checked={ props.selectedFilters.countries.find((countryFilter) => countryFilter.code == country.code) ? true : false} readOnly />
                            <label >{country.name == 'EU28' ? '' : `(${country.code})`} {country.name}</label>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    )
}

export default IndividualCountrySelect;